<div class="modal-content">
  <!--Header-->
  <div class="modal-header d-flex justify-content-between align-items-center border-bottom-0 pb-0">
    <div class="modal-title">
      <h4 class="mb-0">Purchase Item</h4>
    </div>
    <button type="button" class="close-btn float-end" aria-label="Close" (click)="closeModalClick()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="modal-body pb-0 pt-3">
    <form [formGroup]="optimizer_form" (ngSubmit)="submitClick()">
      <!-- Item Info Row -->
      <div class="row align-items-center mb-4 px-2">
        <label class="col-sm-2 col-form-label text-light text-end"><span class="required text-danger me-1">*</span>UPC:</label>
        <div class="col-sm-4 d-flex gap-2">
          <input type="text" class="form-control modern-input flex-grow-1" style="width: auto" formControlName="item_upc" />
          <button type="button" class="btn modern-btn primary-btn d-flex align-items-center" (click)="searchItem()">
            Search
          </button>
        </div>
        <label class="col-sm-2 col-form-label text-light text-end">Model:</label>
        <div class="col-sm-4">
          <input type="text" class="form-control modern-input w-100 text-light" formControlName="item_name" />
        </div>
        <label class="col-sm-2 col-form-label text-light text-end mt-3">Description:</label>
        <div class="col-sm-10 mt-3">
          <input type="text" class="form-control modern-input w-100 text-light" formControlName="item_description" />
        </div>
      </div>

      <hr class="divider-modern mb-4" />

      <!-- Desired Qty -->
      <div class="row mb-3 align-items-center px-2">
        <label for="desired_qty" class="col-sm-2 col-form-label text-light text-end mb-0">
          <span class="required text-danger me-1">*</span>Desired Qty:
        </label>
        <div class="col-sm-4">
          <input type="number" class="form-control modern-input w-100" formControlName="desired_qty" id="desired_qty" />
        </div>
      </div>

      <!-- Legend -->
      <div class="row mt-4 px-2 mb-3">
        <div class="col-12 px-2 text-start small">
          <span class="text-danger">*</span>
          <span class="text-light"> Denotes required fields</span>
        </div>
      </div>

      <!-- Buttons -->
      <div class="modal-footer border-top-0 d-flex justify-content-between mt-0 px-0 pt-0">
        <button type="button" class="btn modern-btn secondary-btn px-4" (click)="closeModalClick()">
          Cancel
        </button>
        <button type="submit" class="btn modern-btn primary-btn px-4" [disabled]="optimizer_form.invalid">
          Add Item
        </button>
      </div>
    </form>
  </div>
</div>
